<template>
  <section>
    <div v-if="!showPlayer" class="spotify-button-container">
      <button
        class="spot_button"
        id="${tracks.toString()}"
        @click="fetchSpotifyProfile(name, tracks)"
      >
        <div aria-hidden="true" data-icon="c" class="button_icon"></div>
        <div class="button_txt">Save Playlist to Spotify</div>
      </button>
      <div>
        <em>Saving the playlist will add a spotify player to this app</em>
      </div>
    </div>
    <div v-if="showPlayer" class="spotify-button-container">
      <iframe
        title="Spotify Player: Press play button to listen to playlist."
        :src="playlistUrl"
        width="300"
        height="80"
        frameborder="0"
        allowtransparency="true"
        allow="encrypted-media"
      ></iframe>
    </div>
  </section>
</template>

<script>
import { isMemoized, memoizePlaylist } from "@/utils/memoize";
import { getSpotifyToken } from "@/utils/spotify-token";
export const auth_header = new Headers({
  Authorization: `Bearer ${sessionStorage.accessToken}`
});

// const isLocalHost = window.location.origin.indexOf("localhost") > -1;
// const baseUrl = isLocalHost
//   ? "https://localhost:8080/"
//   : "https://musicwhereyouare.com/" || "https://www.musicwhereyouare.com";
export default {
  name: "SpotifyButton",
  props: ["tracks", "name", "showPlayer", "property"],
  data: function() {
    return {
      playlistUrl: ""
    };
  },

  methods: {
    fetchSpotifyProfile(name, tracks) {
      this.$emit(
        "toggleProperty",
        this.showPlayer,
        this.property || "showPlayer"
      );
      const t = this; // need to access to class inside `thens`
      const url = "https://api.spotify.com/v1/me";

      return fetch(url, {
        method: "GET",
        headers: auth_header
      })
        .then(response => {
          if (response.status === 401) {
            sessionStorage.removeItem("accessToken");
            getSpotifyToken();
          }
          return response.json();
        })
        .then(function(data) {
          const username = data.id;
          const user_url = `https://api.spotify.com/v1/users/${username}/playlists`;
          if (isMemoized(name)) {
            t.playlistUrl = `https://open.spotify.com/embed/playlist/${isMemoized(
              name
            )}`;
            return;
          }
          fetch(user_url, {
            headers: auth_header,
            method: "POST",
            body: JSON.stringify({
              name: name,
              public: true
            })
          })
            .then(json => {
              return json.json();
            })
            .then(json => {
              const id = json.id;
              memoizePlaylist(name, id);
              const tracksLength = tracks.length;
              t.playlistUrl = `https://open.spotify.com/embed/playlist/${id}`;
              addTracksToPlaylist(0, tracks, id, user_url, t);
            });
        });
    }
  }
};

export function addTracksToPlaylist(x = 0, tracks, id, user_url, context) {
  // get rid of passing `this`
  const tracksLength = tracks.length;
  // create a promise and only iterate to next tracks once that has resolved

  var promises = [];
  var position = 0;
  if (x <= tracksLength) {
    const upperLimiter = x < tracksLength - 50 ? x + 50 : tracksLength;
    const mappedTracks = tracks
      .map(track => `spotify%3Atrack%3A${track.id}`)
      .join(",");
    const tracksToSend = tracks.slice(x, upperLimiter);
    let trackIds = tracksToSend.map(track => `spotify%3Atrack%3A${track.id}`);
    const playlist_url = `${user_url}/${id}/tracks?position=${x}&uris=${trackIds.join(
      ","
    )}&market=US`;

    return fetch(playlist_url, {
      method: "POST",
      headers: auth_header
    }).then(data => {
      x = x + 50;
      if (x === 100 || x === tracksLength) {
        memoizePlaylist(`${user_url}/${id}`, `${user_url}/${id}`);
        context.showPlayer = true;
      }
      addTracksToPlaylist(x, tracks, id, user_url, context);
    });
  }
}
</script>

<style>
.spotify-button-container {
  text-align: left;
  padding: 0 24px 0;
}
@media screen and (min-width: 320px) and (max-width: 799px) {
  .spotify-button-container {
    padding: 24px;
  }
}
</style>
